/* Full-width (parallax) hero drift. A continuous requestAnimationFrame loop reads
   each hero's position every frame and EASES the transform toward its target
   (per-frame lerp — same idea as GSAP ScrollTrigger `scrub`).

   iOS note: Safari suspends JS during momentum/fling scrolling, so nothing can
   move mid-fling. We deliberately do NOT snap when JS wakes — we ease into the
   final position, turning the "click into place" into a smooth glide. Sets
   --parallax-shift on each .pdp-hero-feature--parallax; ::before reads it as a
   composited translateY. Respects prefers-reduced-motion. */
(function () {
  function init() {
    if (window.__ssParallax) return;
    var heroes = [].slice.call(document.querySelectorAll('.pdp-hero-feature--parallax'));
    if (!heroes.length) return;
    window.__ssParallax = true;
    var MAX = 22;     // % of the 140%-tall image layer
    var EASE = 0.055; // extra float — keeps drifting a moment after you stop
    var reduce = window.matchMedia('(prefers-reduced-motion: reduce)');
    var cur = heroes.map(function () { return 0; });
    function frame() {
      var vh = window.innerHeight || document.documentElement.clientHeight;
      for (var i = 0; i < heroes.length; i++) {
        var el = heroes[i], r = el.getBoundingClientRect();
        if (r.bottom < -140 || r.top > vh + 140) continue;
        var target = 0;
        if (!reduce.matches) {
          var pr = (vh - r.top) / (vh + r.height);
          pr = pr < 0 ? 0 : (pr > 1 ? 1 : pr);
          target = -(pr * MAX);
        }
        cur[i] += (target - cur[i]) * EASE;          // always ease — never snap
        if (Math.abs(target - cur[i]) < 0.005) cur[i] = target;
        el.style.setProperty('--parallax-shift', cur[i].toFixed(3) + '%');
      }
      requestAnimationFrame(frame);
    }
    requestAnimationFrame(frame);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
